
import * as React from 'react';
import styled from "@emotion/styled";
import { css } from "@emotion/core";

import Box from './box';


export default class FlexGrid extends React.Component {
  render() {
    return <Row {...this.props}>{this.props.children}</Row>;
  }
}
//Column Fixed
const fixed = css`
  flex:initial;
`;
//Column Content Alignment
const colTop = css`
  justify-content: flex-start !important;
  flex-direction: column;
  display: flex;
`;
const colMiddle = css`
  justify-content: center;
  flex-direction: column;
  display: flex;
`;
const colBottom = css`
  justify-content: flex-end !important;
  flex-direction: column;
  display: flex;
`;

//Column Vert Alignment
const colAlignTop = css`
  align-self: flex-start;
`;
const colAlignMiddle = css`
  align-self: center;
`;
const colAlignBottom = css`
  align-self: flex-end;
`;
//Reorder Columns
const colFirst = css`
  order:-1;
`;
const colLast = css`
  order:1;
`;
//////////////////////////

//Row Reverse
const rowReverse = css`
  flex-direction: row-reverse;
`;
//Column Distribution
const rowAround = css`
  justify-content: space-around;
`;
const rowBetween = css`
  justify-content: space-between;
`;
//Horizonal row column alignment 
const rowStart = css`
  justify-content: flex-start;
`;
const rowCenter = css`
  justify-content: center;
`;
const rowEnd = css`
  justify-content: flex-end;
`;

/////////////////////////
//Media Queries
//How do I write media queries into here? 
// const rowEnd = css`
// @media (max-width: 200px;) {
//   justify-content: flex-end;
// }
// `;


//Grid Row 
const Row = styled(Box)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  flex: 0 1 auto;
  margin: ${({ gutterWidth }) => (gutterWidth != null ? `0 ${gutterWidth * -1}px` : '0 -8px')};
  ${props => props.rowReverse && rowReverse}
  ${props => props.rowAround && rowAround}
  ${props => props.rowBetween && rowBetween}
  ${props => props.rowStart && rowStart}
  ${props => props.rowCenter && rowCenter}
  ${props => props.rowEnd && rowEnd}

  > [data-flexgrid="column"] {
    padding: ${({ gutterWidth }) => (gutterWidth != null ? `0 ${gutterWidth}px` : '0 8px')};
  }
`;
//////////////////////////////
//I want gutterWidth to define the negative margin and the padding in the cols. 
//////////////////////////////

export class Col extends React.Component {
  render() {
    return <Column data-flexgrid="column" {...this.props}>{this.props.children}</Column>;
  }
}

//Grid Column
const Column = styled('div')`
  flex: 0 0 auto;
  /*grow takes any number or defaults to 1 */
  flex-grow: ${({ grow }) => grow ? grow:"1"};
  /*percent takes any % or defaults to auto */
  flex-basis: ${({ percent }) => percent ? percent:"auto"};
  /*percent takes any % or defaults to 100% */
  max-width: ${({ percent }) => percent ? percent:"100%"};
  min-width: 0;
  

  ${props => props.fixed && fixed}
  
  ${props => props.colTop && colTop}
  ${props => props.colBottom && colBottom}
  ${props => props.colMiddle && colMiddle}
  ${props => props.colAlignTop && colAlignTop}
  ${props => props.colAlignMiddle && colAlignMiddle}
  ${props => props.colAlignBottom && colAlignBottom}
  
  ${props => props.colFirst && colFirst}
  ${props => props.colLast && colLast}
`;



//Saving for reference
////////////////////////////////////////////////////////////
// const Column = styled('div')`
//   flex: ${({ fixed }) => fixed ? "initial" : "0 0 auto"};
//   flex-grow: ${({ fixed, grow }) => fixed ? "initial" : grow ? grow:"1"};
//    ${({ alignTop }) => alignTop && 'align-self: flex-start;'};

//Row
// margin: ${({ gutterWidth }) => (gutterWidth ? `0 ${gutterWidth}` : '0 -8px')};